const ok = 'ok';
const warn = 'warn';
const error = 'error';

const severity = [ok, warn, error];

export default {
  ok,
  warn,
  error,
  severity,
};
